// VÁGÓLAP — egy hely a másolásra. A böngésző API-ja nem mindenhol érhető el (nem biztonságos kontextus, régi
// böngésző, megtagadott engedély), ezért a hívó nem a `navigator.clipboard`-ot hívja, hanem ezt: az eredményt
// (`true` / `false`) kapja vissza, és ő dönti el, milyen visszajelzést ad (a hiba nem tűnhet el némán).
import { toast } from 'sonner';

/** Szöveg a vágólapra. `false`, ha a böngésző nem engedte vagy nem támogatja. */
export async function copyText(text: string): Promise<boolean> {
  if (typeof navigator === 'undefined' || navigator.clipboard === undefined) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // a megtagadott engedély nem kivétel a hívónak, hanem `false` — ő ad róla hiba-toastot
    return false;
  }
}

/** Másolás + a szokásos toast-visszajelzés (siker / hiba) — a felületek többségének ennyi kell. */
export async function copyWithToast(
  text: string,
  messages: { success: string; error: string },
): Promise<void> {
  if (await copyText(text)) toast.success(messages.success);
  else toast.error(messages.error);
}
